import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import styled from 'styled-components';
import {
    IM_PAYING_MYSELF_CAPITALIZED_TEXT,
    InsuranceForm,
} from '@zocdoc-frontend-common/components-insuranceform';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';
import { InsuranceConfirmedInNetwork } from '../../pages/ReviewAndBook/InsuranceConfirmedInNetwork';
import { isVaccineProcedure } from '../../utils/isCovidVaccine';

export class InsuranceFormWrapper extends React.Component {
    static propTypes = {
        insuranceCarrierId: PropTypes.string,
        insurancePlanId: PropTypes.string,
        insuranceIsAccepted: PropTypes.bool,
        onChangeCarrier: PropTypes.func,
        onChangePlan: PropTypes.func,
        onClickCarrier: PropTypes.func,
        onClickPlan: PropTypes.func,
        procedureId: PropTypes.string,
        trackPreloadInsuranceCarrier: PropTypes.func,
        trackPreloadInsurancePlan: PropTypes.func,
        receivedBookingState: PropTypes.bool,
        specialtyId: PropTypes.string,
        shouldShowInsuranceAdvocacy: PropTypes.bool,
        __forceShowInsuranceAdvocacy: PropTypes.bool,
        insuranceIsValidating: PropTypes.bool,
    };

    static defaultProps = {
        insuranceCarrierId: '-2',
        insurancePlanId: '-1',
        onChangeCarrier: noop,
        onChangePlan: noop,
        onClickCarrier: noop,
        onClickPlan: noop,
        trackPreloadInsuranceCarrier: noop,
        trackPreloadInsurancePlan: noop,
        receivedBookingState: false,
        specialtyId: undefined,
        __forceShowInsuranceAdvocacy: false,
    };

    _trackedPreloadIds = false;

    componentDidUpdate() {
        const {
            insuranceCarrierId,
            insurancePlanId,
            receivedBookingState,
            trackPreloadInsuranceCarrier,
            trackPreloadInsurancePlan,
        } = this.props;

        if (receivedBookingState && !this._trackedPreloadIds) {
            // Received booking state for the first time
            trackPreloadInsuranceCarrier(insuranceCarrierId);
            trackPreloadInsurancePlan(insurancePlanId);
            this._trackedPreloadIds = true;
        }
    }

    render() {
        const {
            insuranceCarrierId,
            insurancePlanId,
            insuranceIsAccepted,
            onChangeCarrier,
            onChangePlan,
            onClickCarrier,
            onClickPlan,
            procedureId,
            providerFullName,
            specialtyId,
            sendMetric,
            shouldShowInsuranceAdvocacy,
            __forceShowInsuranceAdvocacy,
            shouldShowMentalHealthOONBenefits,
            insuranceIsValidating,
        } = this.props;

        const isInsuranceOutOfNetwork =
            parseInt(insuranceCarrierId, 10) >= 0 && !insuranceIsAccepted;
        const procedureIdInt = parseInt(procedureId, 10);
        const imPayingMyselfText = isVaccineProcedure(procedureIdInt)
            ? "I Don't Have Insurance"
            : IM_PAYING_MYSELF_CAPITALIZED_TEXT;

        return (
            <>
                <InsuranceForm
                    carrierId={insuranceCarrierId}
                    imPayingMyselfText={imPayingMyselfText}
                    onChangeCarrier={onChangeCarrier}
                    onClickCarrier={onClickCarrier}
                    onClickPlan={onClickPlan}
                    onChangePlan={onChangePlan}
                    planId={insurancePlanId}
                    specialtyId={specialtyId}
                />
                {insuranceIsAccepted && (
                    <StyledInsuranceConfirmedInNetwork
                        __forceShowInsuranceAdvocacy={
                            __forceShowInsuranceAdvocacy
                        }
                        shouldShowInsuranceAdvocacy={
                            shouldShowInsuranceAdvocacy
                        }
                        sendMetric={sendMetric}
                    />
                )}
                {shouldShowMentalHealthOONBenefits &&
                    !insuranceIsValidating &&
                    isInsuranceOutOfNetwork && (
                        <OONParagraph data-test="out-of-network-status">
                            Out-of-network for {providerFullName}
                        </OONParagraph>
                    )}
            </>
        );
    }
}

const StyledInsuranceConfirmedInNetwork = styled(InsuranceConfirmedInNetwork)`
    margin-top: 5px;
`;

const OONParagraph = styled.p`
    color: #0060cc;
    font: 13px/20px ${FontFamily.SharpSansSemibold};
    margin-top: 4px;
`;
